const BlogList = {
  parts: [
    'container',
    'listContainerWrapper',
    'listContainer',
    'list'
  ],
  baseStyle: {
    container: {
      bg: 'brandColors.primaryBG', // #F7F5F0
    },
    listContainerWrapper: {
      maxWidth: '1440px',
      display: 'flex',
      flexDirection: 'column',
      mx: 'auto',
      px: {base: 5, md: 20}, // 20px mobile, 80px desktop
      pt: {base: 4, md: 6}, // 16px mobile, 24px desktop
      pb: {base: 12, md: 20}, // 48px mobile, 80px desktop
    },
    listContainer: {
      flex: '0 0 100%',
    },
    list: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      columnGap: 10,
      rowGap: {base: 15.25, md: 20},
      alignSelf: 'stretch',
      flexWrap: 'wrap',
      flex: '0 0 100%',
      sx: {
        ' > div': {
          maxWidth: {base: 'full', md: 'calc(50% - 20px)'},
          flex: {base: '0 0 100%', md: '0 0 calc(50% - 20px)'},
          p: 0,
        },
        ' > div:nth-of-type(5n - 2), > div:nth-of-type(5n - 1), > div:nth-of-type(5n)': {
          maxWidth: {base: 'full', md: 'calc(50% - 20px)', lg: 'calc(33.333% - 26.666px)'},
          flex: {base: '0 0 100%', md: '0 0 calc(50% - 20px)', lg: '0 0 calc(33.333% - 26.666px)'},
        },
        ' > div:nth-of-type(10n - 9), > div:nth-of-type(10n - 3)': {
          maxWidth: {base: 'full', md: 'calc(50% - 20px)', lg: 'calc(58.5937% - 20px)'},
          flex: {base: '0 0 100%', md: '0 0 calc(50% - 20px)', lg: '0 0 calc(58.5937% - 20px)'},
        },
        ' > div:nth-of-type(10n - 8), > div:nth-of-type(10n - 4)': {
          maxWidth: {base: 'full', md: 'calc(50% - 20px)', lg: 'calc(41.4062% - 20px)'},
          flex: {base: '0 0 100%', md: '0 0 calc(50% - 20px)', lg: '0 0 calc(41.4062% - 20px)'},
        },
      },
    },
  },
  variants: {
    default: {},
    filterOpen: {
      listContainerWrapper: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        gap: 10,
      },
      listContainer: {
        width: 'calc(100% - 290px - 40px)',
        flex: '0 0 calc(100% - 290px - 40px)',
      },
    },
  },
};

export default BlogList;
